import { Meteor } from 'meteor/meteor';
import { check } from 'meteor/check';
import TelemetryConnections from '../TelemetryConnections';

Meteor.publish('telemetryConnections', function telemetryConnections() {
  return TelemetryConnections.find({});
});

// Note: telemetryConnections.view is also used when editing an existing document.
Meteor.publish('telemetryConnections.view', function telemetryConnectionsView(
  telemetryConnectionId
) {
  check(telemetryConnectionId, String);
  return TelemetryConnections.find({ _id: telemetryConnectionId, owner: this.userId });
});

Meteor.publish('gmsConnections', function gmsConnections() {
  return TelemetryConnections.find({ url: { $exists: false } });
});

Meteor.publish('gmsConnections.public', function gmsConnectionsPublic(gmsConnectionId) {
  check(gmsConnectionId, String);
  return TelemetryConnections.find(
    { _id: gmsConnectionId, url: { $exists: false } },
    { fields: { ip: 1, port: 1, domain: 1 } }
  );
});
